export function hasUnassignedPatientFacingWork(item) {
  const visits = Array.isArray(item?.procedure_visits) ? item.procedure_visits : [];
  if (visits.length === 0) return item?.phase_number == null;
  return visits.some((visit) => (visit?.phase_number ?? item?.phase_number) == null);
}

export function collectPatientFacingPhaseNumbers(items = [], phaseNames = {}) {
  const used = new Set();
  for (const item of items) {
    if (item?.phase_number != null && Number(item.phase_number) > 0) {
      used.add(Number(item.phase_number));
    }
    const visits = Array.isArray(item?.procedure_visits) ? item.procedure_visits : [];
    for (const visit of visits) {
      if (visit?.phase_number != null && Number(visit.phase_number) > 0) {
        used.add(Number(visit.phase_number));
      }
    }
  }
  for (const key of Object.keys(phaseNames || {})) {
    const phaseNumber = Number(key);
    if (Number.isFinite(phaseNumber) && phaseNumber > 0) {
      used.add(phaseNumber);
    }
  }
  return used;
}
